export default "__VITE_ASSET__DpOj7QCG__"